import GET_PRICING_DATA_QUERY from './queries/getPricingData.graphql'
import REQUEST_QUOTE_MUTATION from './mutations/requestQuote.graphql'
import SUBSCRIBE_TO_PLAN_MUTATION from './mutations/subscribeToPlan.graphql'

export const queries = [
  {
    query: GET_PRICING_DATA_QUERY,
    props: ({ data }) => {
      if (data.loading || data.error) {
        return {
          loading: data.loading,
          error: data.error
        }
      }
      let me = data.me || { group: {} }
      const currentSubscription = me.subscription || false
      const isCustom = ((me.school && !me.subscription) ||
        (me.school && me.subscription && me.school.subscriptionEndDate > me.subscription.current_period_end * 1000) ||
        (me.school && me.subscription && me.school.subscriptionEndDate < me.subscription.current_period_end * 1000 && me.subscription.status !== 'active'))
      return {
        loading: data.loading,
        error: data.error,
        parent: me.parent,
        countryCode: me.group.countryCode,
        trialEndDate: !me.school ? me.subscriptionEndDate : null,
        currentSubscription: {
          ...(me.subscription || {}),
          subscriptionEndDate: isCustom
            ? me.school.subscriptionEndDate
            : me.subscription ? me.subscription.current_period_end * 1000 : null, // Stripe UNIX timestamps
          discountPercentage: currentSubscription.discount
            ? currentSubscription.discount.coupon
              ? currentSubscription.discount.coupon.percent_off
              : null
            : null,
          custom: isCustom
        },
        products: me.availableProducts || []
      }
    },
    options: {
      fetchPolicy: 'network-only'
    }
  }
]

export const mutations = [
  {
    mutation: SUBSCRIBE_TO_PLAN_MUTATION,
    props: ({ mutate }) => ({
      subscribeToPlan: (stripeToken, planId, coupon) =>
        mutate({
          variables: {
            stripeToken,
            planId,
            coupon
          }
        })
    })
  },
  {
    mutation: REQUEST_QUOTE_MUTATION,
    props: ({ mutate }) => ({
      requestQuote: (questions, plan) =>
        mutate({
          variables: {
            quote: { questions: questions.map((q) => ({ ...q, answer: `${q.answer}` })), plan }
          }
        })
    })
  }
]
